<template>
  <div :class="$style.container">
    <!-- Поле выобора начальной даты периода -->
    <masked-date-input
      v-model="form.dateFrom"
      v-m-r="10"
      @change="handleChange"
    />
    <!-- Поле выобора конечной даты периода -->
    <masked-date-input
      v-model="form.dateTo"
      v-m-r="10"
      @change="handleChange"
    />
    <!-- Иконка для отображения пресетов -->
    <!-- @TODO: если компонент будет переисхользоваться, переименовать название события, сейчас очень специфичное -->
    <base-icon
      v-color:white
      v-cursor:pointer
      name="basic_lightning"
      @click="$emit('show-presets')"
    />
  </div>
</template>

<script>
import { getMomentConstructor, formatDateToCustomDateFormat } from 'lib/utils/date';

import MaskedDateInput from 'molecules/common/MaskedDateInput';

const moment = getMomentConstructor();

export default {
  name: 'DatepickerToolbar',
  components: {
    MaskedDateInput,
  },
  props: {
    /**
     * { from: moment, to: moment } | moment
     */
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        dateFrom: '',
        dateTo: '',
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.form.dateFrom = (val.from && val.from.isValid()) ? formatDateToCustomDateFormat(val.from, 'DD.MM.YYYY') : '';
        this.form.dateTo = (val.to && val.to.isValid()) ? formatDateToCustomDateFormat(val.to, 'DD.MM.YYYY') : '';
      },
    },
  },
  methods: {
    handleChange() {
      this.$emit('change', {
        from: moment(this.form.dateFrom, 'DD-MM-YYYY'),
        to: moment(this.form.dateTo, 'DD-MM-YYYY'),
      });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +align-items(center)

  .title
    +font-type('semi-bold', 20, 30)
    color: var(--color-white)
    margin: 0 0 20px

    +respond-to('medium')
      margin: 0 20px 0 0
</style>
